import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-upload-file-wrap" }
const _hoisted_2 = { class: "ui-upload-file-hidden" }
const _hoisted_3 = { class: "ui-upload-file-block" }

import { computed, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ui-upload-file',
  props: {
  /**
   * Поле для чтения
   */
  placeholder: {
    type: String,
    default: "Выберите файл",
  },
  /**
   * Позволяет очищать компонент
   */
  clearable: {
    type: Boolean,
    default: true,
  },
  /**
   * Удаляет возможность щелкнуть или нацелить ввод
   */
  disabled: {
    type: Boolean,
  },
  /**
   * Добавляет к входным данным множественный атрибут, позволяющий выбирать несколько файлов.
   */
  multiple: {
    type: Boolean,
  },
  /**
   * Типы файлов для загрузки
   */
  accept: {
    type: String,
    default: "image/png, image/jpeg",
  },
  /**
   * Иконка
   */
  icon: {
    type: String,
    default: "mdi mdi-image-plus-outline",
  },
  /**
   * Текст
   */
  label: {
    type: String,
    default: "Добавить фото",
  },
},
  emits: ["change"],
  setup(__props, { emit }) {

const props = __props;



/**
 * События
 */


const innerFiles = ref();

/**
 * Значение
 */
const files = computed({
  get: () => {
    return innerFiles.value;
  },
  set: (value) => {
    emit("change", value);
    innerFiles.value = [];
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_file_input, {
        modelValue: files.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((files).value = $event)),
        class: "ui-upload-file",
        clearable: __props.clearable,
        disabled: __props.disabled,
        multiple: __props.multiple,
        accept: __props.accept
      }, null, 8, ["modelValue", "clearable", "disabled", "multiple", "accept"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("i", {
        class: _normalizeClass(__props.icon)
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(__props.label), 1)
    ])
  ]))
}
}

})